import React from 'react';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';

const ResetPassword = () => {
  return (
    <div className="flex items-center justify-center py-12">
      <ResetPasswordForm />
    </div>
  );
};

export default ResetPassword;